/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import {
  Grid,
  Panel,
  Button,
  Row,
  Col,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import dashboardActions from 'loraactions/dashboard';
import callAPI from '@/api/callAPI';
import DetailHeader from '../DetailHeader';
import TimeSelect from '../TimeSelect';
import DeviceModal from '../DeviceModal';
import EditName from '../EditName';
import RefreshBtn from '../RefreshBtn';
import Charts from '../Charts';
import DpsModal from '../DpsModal';
import styles from './styles.scss';

const kLoops = 100;
const kInterval = 6;

const propTypes = {
  intl: PropTypes.object.isRequired,
  dashId: PropTypes.string.isRequired,
  dashboardData: PropTypes.object.isRequired,
  appState: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
  getDashboard: PropTypes.func.isRequired,
  getDps: PropTypes.func.isRequired,
  getDeveui: PropTypes.func.isRequired,
  getRefreshCount: PropTypes.func.isRequired,
  deveuis: PropTypes.array.isRequired,
};

class SingleDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dashboardData: props.dashboardData,
      appState: props.appState,
      checkedId: [],
      extNew: { charts: [], deveui: [] },
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.handleOperation = this.handleOperation.bind(this);
    this.handleOnConfirmDps = this.handleOnConfirmDps.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.refresh = 0;
  }

  componentWillMount() {
    const { dashId, getDashboard } = this.props;
    getDashboard(dashId);
  }

  componentWillReceiveProps(nextProps) {
    const { dashboardData, appState, deveuis } = nextProps;
    if (dashboardData !== this.props.dashboardData) {
      const { status, data } = dashboardData;
      if (status === 'success' && data) {
        this.handleData(dashboardData);
      }
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
    if (deveuis !== this.props.deveuis) {
      this.deveuis = deveuis;
    }
  }

  componentWillUnmount() {
    this.refresh = 0;
  }

  handleData(dashboardData) {
    const { ext } = dashboardData.data;
    const checkedId = JSON.parse(ext).deveui;
    this.deveuis = checkedId;
    let dpsAll = [];
    const dpspart = [];
    dpsAll = _.map(JSON.parse(ext).charts, (item) => {
      if (_.isArray(item.type)) {
        _.map(item.type, (i) => {
          dpspart.push(i);
        });
      }
      return item.type;
    });
    _.map(dpspart, d => (dpsAll.push(d)));
    dpsAll = _.filter(dpsAll, dAll => (!_.isArray(dAll)));
    this.setState({
      checkedId,
      dps: dpsAll,
      dashboardData,
      extNew: JSON.parse(ext),
    }, () => {
      this.props.getDps(this.state.dps);
    });
  }

  handleOperation(d = [], deveui) {
    let { dashboardData: { data: { ext } } } = this.state;
    ext = JSON.parse(ext);
    ext = { ...ext, deveui };
    callAPI({
      endpoint: `/lora/dashboards/${this.props.dashId}`,
      method: 'PUT',
      body: {
        ext: JSON.stringify(ext),
      },
    })
      .then(() => {})
      .catch(() => {});
    this.props.getDeveui(deveui);
    this.setState({ checkedId: deveui });
  }

  handleDelSuc(e, d) {
    this.setState({ extNew: e });
    let { dps } = this.state;
    if (_.isArray(d)) {
      dps = _.difference(dps, d);
    } else {
      dps = _.filter(dps, item => item !== d);
    }
    this.setState({ dps });
  }

  handleOnConfirmDps(dpsNew, modalType) {
    let { dashboardData: { data: { ext } } } = this.state;
    const { extNew } = this.state;
    ext = JSON.parse(ext);
    let addCharts;
    let charts = extNew.charts;
    let dpsNewTwo = _.split(dpsNew, ',');
    dpsNewTwo = _.filter(dpsNewTwo, dp => (dp !== ''));
    _.remove(dpsNewTwo, d => (d === 'lat' || d === 'lng'));
    if (modalType === 'single') {
      addCharts = _.map(dpsNewTwo, item => ({ type: item }));
      charts = _.concat(charts, addCharts);
      charts = _.uniqWith(charts, _.isEqual);
    } else if (modalType === 'merge') {
      addCharts = { type: dpsNewTwo };
      charts = _.concat(charts, addCharts);
      charts = _.uniqWith(charts, _.isEqual);
    }
    ext = { ...ext, deveui: this.deveuis, charts };
    callAPI({
      endpoint: `/lora/dashboards/${this.props.dashId}`,
      method: 'PUT',
      body: {
        ext: JSON.stringify(ext),
      },
    })
      .then(() => {})
      .catch(() => {});
    this.setState({
      showDpsModal: false,
      reset: new Date(),
      modalType,
      extNew: ext,
    });
    this.props.getDps(dpsNewTwo);
  }

  handleRefresh() {
    if (this.refresh === (kLoops + 1)) {
      this.refresh = 0;
      this.setState({ selectDisabled: false });
    } else {
      this.props.getRefreshCount(this.refresh);
      this.setState({ isRefreshing: true });
      this.refresh += 1;
      _.delay(() => {
        this.setState({ isRefreshing: false });
      }, 1000);
      this.setState({ selectDisabled: true });
    }
  }

  handleOneClick() {
    this.refresh = 0;
    this.setState({ selectDisabled: false });
  }

  handleOnHideDps() {
    this.setState({ showDpsModal: false });
  }

  render() {
    const { appId, dashId } = this.props;
    const {
      reset = 0,
      dashboardData: { data },
      showDpsModal = false,
      showDeviceModal = false,
      isRefreshing = false,
      checkedId,
    } = this.state;
    // let { dps } = this.state;
    if (!data) {
      return null;
    }
    // dps = dps || _.map(JSON.parse(data.ext).charts, item => item.type);
    // dps = _.filter(dps, d => (d !== ''));
    // dps = _.join(dps, ',');
    const deveui = JSON.parse(data.ext).deveui;
    const header = (
      <div className={`clearfix ${styles.leftTool}`}>
        <span className="pull-left">
          <EditName name={data.name} dashId={dashId} />
        </span>
        <Link
          to={`/application/${this.props.appId}/devices/${checkedId[0]}`}
          className={styles.device}
        >
          {checkedId[0]}
        </Link>
        <div className="pull-right">
          <Button
            bsStyle="aisz-success-b"
            className={styles.marginRm}
            onClick={() => this.setState({ showDpsModal: true })}
          >
            {this.intlMsg.msg('add.dpschart')}
          </Button>
          <Button
            bsStyle="aisz-primary-b"
            onClick={() => this.setState({ showDeviceModal: true })}
          >
            {this.intlMsg.msg('changedevice')}
          </Button>
        </div>
      </div>
    );
    return (
      <div ref={(input) => { this.container = input; }} >
        <DetailHeader dash={data} />
        <Grid fluid>
          <div>
            <Panel bsStyle="aisz-white" header={header} styleName="add-panel">
              <Row>
                <Col md={11}>
                  <span className="pull-left">
                    <TimeSelect />
                  </span>
                </Col>
                <Col md={1} className="text-right" styleName="refresh">
                  <RefreshBtn
                    loops={kLoops}
                    interval={kInterval}
                    reloading={isRefreshing}
                    onReload={this.handleRefresh}
                    onOneClick={() => this.handleOneClick()}
                  />
                </Col>
              </Row>
            </Panel>
            <Charts
              dashId={dashId}
              reset={reset}
              appId={appId}
              onDeleteSuc={(e, d) => this.handleDelSuc(e, d)}
            />
          </div>
          <DpsModal
            showModal={showDpsModal}
            // dps={dps}
            appId={appId}
            onConfirm={this.handleOnConfirmDps}
            onHide={() => this.handleOnHideDps()}
          />
          <DeviceModal
            appId={appId}
            showModal={showDeviceModal}
            onChoose={this.handleOperation}
            onHide={() => this.setState({ showDeviceModal: false })}
            checkedId={deveui}
          />
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appState: state.app.getApp,
  dashId: ownProps.params.dashid,
  appId: ownProps.params.id,
  dashboardData: state.dashboard.getDashboard,
  time: state.dashboard.getTimes,
  deveuis: state.dashboard.getDeveui,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getDashboard: dashboardActions.getDashboard,
  getDps: dashboardActions.getDps,
  getDeveui: dashboardActions.getDeveui,
  getRefreshCount: dashboardActions.getRefreshCount,
};

SingleDetail.propTypes = propTypes;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(SingleDetail,
  styles,
)));






// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/SingleDetail/index.jsx